/**
 * /admin/support/$reportId - Admin detail + update for a single report.
 *
 * Same layout + auth-guard pattern as the other admin pages (page-shell +
 * section), matching the inbox index route.
 */

import type { JSX } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageHeader } from '../../../components/ui/PageHeader.js';
import { SupportReportDetail } from '../../../components/admin/SupportReportDetail.js';
import { freshSessionQuery } from '../../../lib/api/queries.js';

export const Route = createFileRoute('/admin/support/$reportId')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role !== 'admin') {
      throw redirect({ to: '/' });
    }
    return null;
  },
  component: AdminSupportDetailPage,
});

function AdminSupportDetailPage(): JSX.Element {
  const { reportId } = Route.useParams();
  return (
    <main className="page-shell" data-testid="admin-support-detail-page">
      <PageHeader eyebrow="Bantuan & support" title="Detail laporan" />
      <section className="section">
        <SupportReportDetail reportId={reportId} />
      </section>
    </main>
  );
}
